import React from 'react';
import './JogadoresTime.css';

import Jogador from './Jogador';

export default props => {
  let i;
  const { acompanhamento = false, idTime, categoria, jogadores, removerJogador } = props;
  const jogadoresLeft = [];
  const jogadoresRight = [];
  for (i = 0; i < jogadores.length; i++) {
    if (jogadores[i]) {
      if (i % 2 === 0) {
        jogadoresLeft.push(
          <Jogador
            acompanhamento={acompanhamento}
            key={i.toString()}
            jogador={jogadores[i]}
            versao="Time"
            removerJogador={removerJogador}
            idTime={idTime}
          />,
        );
      } else {
        jogadoresRight.push(
          <Jogador
            acompanhamento={acompanhamento}
            key={i.toString()}
            jogador={jogadores[i]}
            versao="Time"
            removerJogador={removerJogador}
            idTime={idTime}
          />,
        );
      }
    }
  }

  return (
    <div className="JogadoresTime">
      <p>{`Categoria ${categoria} - ${jogadores.length} jogador${jogadores.length > 1 ? 'es' : ''}`}</p>
      <div className="JTLinha">
        <div className="JTColuna">{jogadoresLeft}</div>
        <div className="JTColuna">{jogadoresRight}</div>
      </div>
    </div>
  );
};
